import React from 'react'
import {Button} from '@startlibs/components'
import {ConfirmDialog} from '@startlibs/form'
import {getFetcher, postFetcher} from '@startlibs/utils'

export const AcceptTermsDialog = ({closeDialog}) =>
  <ConfirmDialog
    title="IMPORTANT LEGAL NOTICE"
    action={() => getFetcher('/StudyAcceptTerms.php').then(() => new Promise(() => window.top.location.reload()))}
    confirm={<Button highlight type="submit">Accept</Button>}
    onSuccess={closeDialog}
    cancelButton={false}
    alternativeButton={<Button.a target="_top" href="/logout.php">Cancel</Button.a>}
  >
    <div>
      <p>
        By logging into this system, you are accepting the following terms and
        conditions. If you do not accept these terms and conditions please
        leave this website.
      </p>
      <p>
        The information contained in this system is the confidential private
        health information of our patients covered by HIPAA or local applicable
        health privacy regulations. You are permitted to review only that
        information necessary for the treatment of your current patients.
      </p>
      <p>
        Should you obtain access to information that is not related to your
        current patients you shall ignore such information, exit the system,
        and inform us immediately.
      </p>
      <p>
        Any use of this system for any other purpose is strictly prohibited
        and will cause us to immediately remove your credentials from our
        system, restrict you from further use, and/or be reported to the
        appropriate authorities.
      </p>
    </div>
  </ConfirmDialog>
